import cx from 'classnames'

import Badge from 'common/components/Badge'
import ButtonWithTooltip from 'common/components/button/withTooltip'
import { containsRtlChars } from 'common/helpers/string'
import { Copy } from 'common/icons'
import { replaceNewLineEmojiAsElement } from 'common/variantsUtils'

type Props = {
  text: string
  isControlVariant: boolean
  isAiControlVariant?: boolean
  onClickCopy: (text: string) => void
}

const VariantCell = ({
  text,
  isControlVariant,
  isAiControlVariant,
  onClickCopy,
}: Props) => {
  const hasRtlChars = containsRtlChars(text)
  const showBadge = isControlVariant || isAiControlVariant

  return (
    <div
      className={cx('flex justify-between items-center', {
        'text-right': hasRtlChars,
      })}
      dir={hasRtlChars ? 'rtl' : 'ltr'}
    >
      <span>
        <span
          className={cx({
            'mr-2': showBadge && !hasRtlChars,
            'ml-2': showBadge && hasRtlChars,
            'text-base': hasRtlChars,
          })}
        >
          {replaceNewLineEmojiAsElement(text)}
        </span>
        {isControlVariant && <Badge text="Control" variant="warning" />}
        {isAiControlVariant && (
          <Badge text="AI Control" variant="control" size="small" />
        )}
      </span>
      <ButtonWithTooltip
        tooltip={false}
        data-cy="copy-variant"
        data-testid="copy-variant"
        title="Copy variant to clipboard"
        className="py-0"
        onClick={() => {
          onClickCopy(text)
        }}
        icon={<Copy />}
      />
    </div>
  )
}

export default VariantCell
